import { AsyncPipe, SlicePipe, TitleCasePipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  output,
  inject,
} from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { AvatarModule } from 'primeng/avatar';
import { PopoverModule } from 'primeng/popover';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject, Observable } from 'rxjs';
import { ClientService } from '@fitness-force/api';
import { TransferType } from '@fitness-force/enum';
import { Store } from '@ngrx/store';
import type { TENANTSINTERFACE, TENANT_MODEL } from '@fitness-force/models';
import { TENANTS_INFO } from '@fitness-force/state';

@Component({
  selector: 'transferred-to',
  templateUrl: './transferred-to.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PopoverModule,
    AvatarModule,
    StyleClassModule,
    ShortNamePipe,
    RouterModule,
    AsyncPipe,
    SlicePipe,
    TitleCasePipe,
  ],
})
export class TransferredToComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly store = inject(Store);
  private readonly clientService = inject(ClientService);

  columnData: Observable<any> = new BehaviorSubject(null);
  readonly onAction = output<{ action: string; columnData: any }>();
  colData = new BehaviorSubject<any>(null);
  showIcon = true;
  locationTransfer = true;
  ngOnInit(): void {
    this.columnData.subscribe({
      next: (col: any) => {
        if (
          TransferType[TransferType.LocationToLocation] === col?.transfer_type
        ) {
          this.locationTransfer = false;
          this.getTenantData(col?.transfer_to_tenant_id);
        } else {
          this.colData.next(col?.transfer_to_client);
          this.showIcon = false;
        }
      },
    });
  }

  getTenantData(tenantId: number) {
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.colData.next(
        tenant.all_tenant.find(
          (currentTenant: TENANT_MODEL) => currentTenant.id === tenantId,
        ),
      );
    });
  }

  // gotoClient(id: any) {
  //   const url = this.router.serializeUrl(
  //     this.router.createUrlTree(['/client/profile/', id])
  //   );
  //   window.open(url, '_blank');
  // }

  getClientType(row: any): string {
    switch (row?.client_status) {
      case 'Client':
        return 'Member';
      default:
        return '';
    }
  }

  clientStatus(client: any): string {
    if (client?.client_status)
      return this.clientService.getClientStatusHtml(
        client.client_status.toString(),
      );
    else return '';
  }

  executeAction(action: string, columnData: any) {
    this.onAction.emit({ action, columnData });
  }
}
